import styled from 'styled-components';
import SectionContainer from '@common/components/SectionContainer';

export const CategoriesWrapper = styled(SectionContainer)`
  margin-top: 96px;
`;

export const NotFound = styled.p`
  text-align: center;
`;
